/* eslint-disable max-len */

import React from 'react';

interface MaxChatProps {
    color?: 'colored' | 'white' | 'gray';
}

const MaxChat: React.FC<MaxChatProps> = ({ color = 'colored' }) => {
    const isWhite = color === 'white';
    const isGray = color === 'gray';

    const getFillColor = () => {
        if (isWhite) return '#FFFFFF';
        if (isGray) return '#899696';
        return undefined;
    };

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_17882_185616)">
                {/* Контейнер с градиентом (только для цветной версии) */}
                {!isWhite && !isGray && (
                    <g
                        clipPath="url(#paint0_angular_17882_185616_clip_path)"
                        data-figma-skip-parse="true"
                    >
                        <g transform="matrix(-0.008 0.0095 -0.0101333 -0.00853333 8 8.08801)">
                            <foreignObject
                                x="-1026.49"
                                y="-1026.49"
                                width="2052.98"
                                height="2052.98"
                            >
                                <div
                                    style={{
                                        background: 'conic-gradient(from 90deg, rgba(64, 194, 253, 1) 0deg, rgba(39, 69, 249, 1) 94.437deg, rgba(157, 73, 221, 1) 210.927deg, rgba(157, 73, 221, 1) 279.111deg, rgba(64, 194, 253, 1) 360deg)',
                                        height: '100%',
                                        width: '100%',
                                        opacity: 1,
                                    }}
                                />
                            </foreignObject>
                        </g>
                    </g>
                )}

                {/* Основной путь фигуры */}
                <path
                    fill={getFillColor()}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.17189 15.9543C6.60169 15.9543 5.87199 15.7241 4.60362 14.8032C3.80132 15.8392 1.26075 16.6489 1.14995 15.2637C1.14995 14.2239 0.92072 13.3452 0.660929 12.3859C0.351482 11.2041 0 9.888 0 7.98102C0 3.42646 3.72111 0 8.12987 0C12.5424 0 16 3.59529 16 8.02321C16.0148 12.3827 12.5125 15.9311 8.17189 15.9543ZM8.23685 3.93678C6.08977 3.82552 4.41641 5.31812 4.04583 7.6587C3.7402 9.59641 4.2827 11.9562 4.74497 12.079C4.96655 12.1327 5.52434 11.6799 5.87199 11.3307C6.44687 11.7296 7.11631 11.9691 7.81279 12.0252C10.0375 12.1327 11.9385 10.4317 12.0878 8.19974C12.1748 5.96306 10.4619 4.06863 8.23685 3.94063V3.93678Z"
                />
            </g>

            <defs>
                <clipPath id="paint0_angular_17882_185616_clip_path">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.17189 15.9543C6.60169 15.9543 5.87199 15.7241 4.60362 14.8032C3.80132 15.8392 1.26075 16.6489 1.14995 15.2637C1.14995 14.2239 0.92072 13.3452 0.660929 12.3859C0.351482 11.2041 0 9.888 0 7.98102C0 3.42646 3.72111 0 8.12987 0C12.5424 0 16 3.59529 16 8.02321C16.0148 12.3827 12.5125 15.9311 8.17189 15.9543ZM8.23685 3.93678C6.08977 3.82552 4.41641 5.31812 4.04583 7.6587C3.7402 9.59641 4.2827 11.9562 4.74497 12.079C4.96655 12.1327 5.52434 11.6799 5.87199 11.3307C6.44687 11.7296 7.11631 11.9691 7.81279 12.0252C10.0375 12.1327 11.9385 10.4317 12.0878 8.19974C12.1748 5.96306 10.4619 4.06863 8.23685 3.94063V3.93678Z"
                    />
                </clipPath>

                <clipPath id="clip0_17882_185616">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default MaxChat;